




















import Vue from "vue";
import Component from "vue-class-component";

@Component({
  components: {},
})
export default class Hero extends Vue {
  private heroHeader = "DO YOU HAVE WHAT IT TAKES";
  private heroSubheader =
    "to join the Tyr Intelligence & Security Private Military Contractors?";
}
